import { AlertTriangle } from "lucide-react";

export const SessionExpiredModal = ({ onClose }) => {
  return (
    <div
      data-testid="session-expired-modal-overlay"
      className="fixed inset-0 z-[9999] flex items-center justify-center bg-black/70 backdrop-blur-sm"
    >
      <div
        data-testid="session-expired-modal"
        className="bg-card border border-border rounded-2xl p-8 max-w-md w-[90%] shadow-2xl text-center"
      >
        <div className="mx-auto w-16 h-16 rounded-full bg-amber-500/15 flex items-center justify-center mb-5">
          <AlertTriangle className="w-8 h-8 text-amber-500" />
        </div>
        <h2
          data-testid="session-expired-title"
          className="text-xl font-semibold text-foreground mb-3"
        >
          Session expirée
        </h2>
        <p
          data-testid="session-expired-message"
          className="text-muted-foreground mb-6 leading-relaxed"
        >
          Votre compte a été connecté sur un autre appareil.
        </p>
        <button
          data-testid="session-expired-ok-btn"
          onClick={onClose}
          className="w-full py-3 px-6 rounded-xl bg-foreground text-background font-medium hover:opacity-90 transition-opacity"
        >
          Compris
        </button>
      </div>
    </div>
  );
};
